import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import CATEGORY_LISTS from '../../../public/assets/constants/category';
import Panel from '@/components/Panel';
import Icon from '@/components/Icon';
import styles from './index.module.less';

const ICONS = {
  1: 'category_started',
  2: 'category_deposit',
  3: 'category_business',
  4: 'category_transfer',
  5: 'category_others',
  6: 'category_investment',
};

interface ItemProps {
  id: number;
  text: string;
  icon: string;
  childs?: ICategory[];
}

const Item = ({ id, text, icon }: ItemProps) => {
  const history = useHistory();

  return (
    <div
      className={styles.categoryItem}
      onClick={() => history.push(`/category/${id}`)}
    >
      <div>
        <Icon iconName={icon} imgClass={styles.icon} />
        <span className={styles.name}>{text}</span>
      </div>
    </div>
  );
};

const Categories: React.FC = () => {
  const { t } = useTranslation();

  return (
    CATEGORY_LISTS.length > 0 && (
      <Panel header={t('title_category')}>
        <div className={styles.categories}>
          {CATEGORY_LISTS.map((item, index) => (
            <Item
              key={item.id}
              id={index + 1}
              childs={item.children}
              text={item.name}
              icon={ICONS[index + 1]}
            />
          ))}
        </div>
      </Panel>
    )
  );
};

export default Categories;
